<template>

    <div class="outer-wrapper">

        <h3 style="text-align: center">Order Summary</h3>

        <div class="order-details-wrapper">

            <div>
                <p>Order Subtotal</p>
                <p class="number-format" >${{ Subtotal }}</p>
            </div>
            <div>
                <p>Tax</p>
                <p class="number-format" >${{ orderTax.toFixed( 2 ) }}</p>
            </div>
            <div>
                <p>Tip</p>
                <p class="number-format" >${{ orderTip }}</p>
            </div>
            <div>
                <p style="font-weight: bold">Total</p>
                <p class="number-format" style="font-weight: bold">${{ orderTotal }}</p>
            </div>
        </div>

        <div class="order-payment-details-wrapper" v-if=" profileInfo.cardDetails.cardLast4 != null || useNewCard ">

            <div class="order-payment-details">
                Using card
                <img :src=" './img/' + profileInfo.cardDetails.cardImage " class="" />
                <p class="card-details">

                    <span v-if=" profileInfo.cardDetails.cardNetwork == 'AMEX' ">&#183;&#183;&#183;&#183; &#183;&#183;&#183;&#183;&#183;&#183; &#183;</span>
                    <span v-else><span v-for=" i in 3 " :key=" i ">&#183;&#183;&#183;&#183; </span></span>
                    {{ profileInfo.cardDetails.cardLast4 }}
                </p>
            </div>
            <div class="use-new-card">

                <p>Use new card?</p>
                <input type="checkbox" id="keepCard" :value=" useNewCard " @click=" toggleNewCard() "/>
            </div>
        </div>
        <div class="card-information-wrapper" v-else>

            <div class="input-wrap" >

                <p class="input-title">card number:</p>
                <input type="text" v-model=" cardInfo.cardNumber " class="input-data" />
            </div>
            <div class="input-wrap" >

                <p class="input-title">name:</p>
                <input type="text" v-model=" cardInfo.name " class="input-data" />
            </div>
            <div class="small-sizing-inputs">

                <div class="input-wrap" >

                    <p class="input-title">exp:</p>
                    <input type="text" v-model=" cardInfo.exp " class="input-data" />
                </div>
                <div class="input-wrap" >

                    <p class="input-title">cvv:</p>
                    <input type="text" v-model=" cardInfo.cvv " class="input-data" />
                </div>
            </div>
            <div class="input-wrap" >

                <p class="input-title">address:</p>
                <input type="text" v-model=" cardInfo.address " class="input-data" />
            </div>
            <div class="input-wrap" >

                <p class="input-title">city:</p>
                <input type="text" v-model=" cardInfo.city " class="input-data" />
            </div>
            <div class="small-sizing-inputs">

                <div class="input-wrap" >

                    <p class="input-title">state:</p>
                    <input type="text" v-model=" cardInfo.state " class="input-data" />
                </div>
                <div class="input-wrap" >

                    <p class="input-title">zip:</p>
                    <input type="text" v-model=" cardInfo.zip " class="input-data" />
                </div>
            </div>
        </div>

        <div class="submit-order-wrapper">

            <p class="order-error" v-if=" orderError != null ">{{ orderError }}</p>
            <button type="button" class="button btn-blue" @click=" submitOrder() ">Send Order</button>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {

        name: 'confirm-order',
        data: function(){

            return {

                cardInfo: {

                    cardNumber : null,
                    name       : null,
                    exp        : null,
                    cvv        : null,
                    address    : null,
                    city       : null,
                    state      : null,
                    zip        : null
                },
                useNewCard : false
            }
        },
        methods: {

            submitOrder(){

                return this.$store.dispatch( 'orderTab/processPaymentInfo', cardInfo )
                    .then( ( encryptedData ) => {

                        if ( encryptedData ) {

                            // console.log( 'Encrypted Data: ', encryptedData );
                            // also passing in saveCard to signal if we should save the card information
                            this.$store.dispatch( 'orderTab/submitOrder', { enc: encryptedData, saveCard: this.saveCard } );
                            return paymentResponse.complete( 'success' );
                        } else {

                            return paymentResponse.complete( 'fail' );
                        }
                    })
            },
            toggleNewCard(){

                this.useNewCard = !this.useNewCard;
            }
        },
        computed: {

            ...mapGetters({

                Subtotal     : 'orderTab/getCost',
                orderTax     : 'orderTab/getTax',
                modalOpen    : 'modal/modalShowing',
                orderError   : 'orderTab/getOrderError',
                orderTip     : 'orderTab/orderTip',
                orderTotal   : 'orderTab/orderTotal',
                profileInfo  : 'auth/profileInfo'
            })
        },
        components: {

        }
    }
</script>

<style scoped>

    .outer-wrapper {

        height: 100%;
        padding-top: 15px;
        display: flex;
        flex-direction: column;
    }

    .outer-wrapper > h3 {

        margin: 0 0 10px;
    }

    .order-details-wrapper {

        border-bottom: 1px solid #ccc;
        margin-bottom: 25px;
    }
    .order-details-wrapper > div {

        display: flex;
        justify-content: space-between;
        padding: 5px 0;
    }

    .small-sizing-inputs {

        display: flex;
        justify-content: space-between;
    }

    .card-information-wrapper {

        margin: 0px 0px 15px;
    }

    .input-title {

        font-weight: bold;
    }
    .input-data {

        width: 100%;
        margin: 3px 1px;
        height: 30px;
        border-radius: 3px;
    }
    .input-data:focus {

        outline: 1px solid blue;
    }


    .submit-order-wrapper {

        margin-top: auto;
    }
    .submit-order-wrapper > button {

        width: 100%;
    }


    .order-payment-details-wrapper {

        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 25px;
    }
    .order-payment-details {

        display: flex;
        margin-bottom: 15px;
    }
        .order-payment-details > img {

            width: 35px;
            height: 21px;
            padding-left: 10px;
        }
        .card-details {

            padding-left: 15px;
            font-weight: bold;
            margin: 0;
        }

    .use-new-card {

        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .use-new-card > input {

        width: 25px;
        height: 25px;
        margin: 2px;
    }
</style>